import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import {
  registrationStatusTextToTypeMap,
  getRegistrationStatusTextArray,
} from '../../utils/textMappings';
import { RegistrationStatusDropDownFilterCell } from './RegistrationStatusDropDownFilterCell';
import { GetString } from '../StringResourceManager';

export const RegistrationStatusFilterCell: any = (
  props: GridCustomFilterCellProps
) => (
  <RegistrationStatusDropDownFilterCell
    {...props}
    data={getRegistrationStatusTextArray()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={registrationStatusTextToTypeMap}
  />
);
